
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class TawkToChatGrid extends Serenity.EntityGrid<TawkToChatRow, any> {
        protected getColumnsKey() { return TawkToChatColumns.columnsKey; }
        protected getDialogType() { return TawkToChatDialog; }
        protected getIdProperty() { return TawkToChatRow.idProperty; }
        protected getInsertPermission() { return TawkToChatRow.insertPermission; }
        protected getLocalTextPrefix() { return TawkToChatRow.localTextPrefix; }
        protected getService() { return TawkToChatService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}